// @flow

import React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { colors } from '../../../styles/GlobalStyle';

import { Icon } from './Icon';

type ButtonLinkRawProps = {
  className?: string,
  text: string,
  functionClick: Function,
};

const ButtonLinkRaw = ({
  className,
  text,
  functionClick,
}: ButtonLinkRawProps) => {
  return (
    <button
      className={className}
      type={'button'}
      onClick={functionClick}
    >
      <span>{text}</span>
      <span>
        <Icon name={'arrow-right'} />
        <Icon name={'arrow-right'} />
      </span>
    </button>
  );
};

export const ButtonLink: StyledComponent<
  ButtonLinkRawProps,
  {},
  typeof ButtonLinkRaw
> = styled(ButtonLinkRaw)`
  font-weight: 900;
  letter-spacing: 0.6px;
  transition: 300ms all ease-out;
  border: 0;
  color: #fff;
  position: relative;
  cursor: pointer;
  outline: 0;
  text-transform: uppercase;
  background-color: transparent;
  height: 60px;
  padding: 0;
  user-select: none;
  display: flex;
  align-items: center;
  text-align: left;

  svg {
    width: 17px;
    height: 15px;
    transition: 300ms all ease-out;
    &:first-child {
      opacity: 0;
      margin-left: -5px;
    }
    &:nth-child(2) {
      margin-left: -10px;
    }
  }

  span:nth-child(2) {
    padding-left: 5px;
    display: flex;
  }

  &:hover {
    color: ${colors.yellow};
    svg:first-child {
      opacity: 1;
      margin-left: 0px;
    }
    svg:nth-child(2) {
      margin-left: 10px;
      opacity: 0;
    }
  }

  &:active {
    transform: scale(0.95) !important;
  }

  &:focus {
    transform: scale(0.95) !important;
    color: ${colors.yellow};
  }
`;
